import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import type { TNewUploadAnalysedFile } from './useNewUpload'
import { PrivateAPI } from '../utils/api'

type TSaveBuildAutoResponse = {
  analysedFile: TNewUploadAnalysedFile
}

type TSaveBuildAutoInput = {
  analysedFileId: string
  removedDTCs: string[]
  selectedMods: number[]
}

const getSaveBuildAutoErrorMessage = (err: unknown) => {
  const defaultMessage = 'An unexpected error occured'

  if (!axios.isAxiosError(err)) {
    return `${defaultMessage} [990]`
  }

  const status = err.response?.status

  if (!status) {
    return `${defaultMessage} [990]`
  }

  if (status >= 400 && status < 500) {
    return `${defaultMessage} [${status}]`
  }

  return defaultMessage
}

const useSaveBuildAuto = () => {
  return useMutation<TSaveBuildAutoResponse, Error, TSaveBuildAutoInput>({
    mutationKey: ['save-build-auto'],
    mutationFn: async ({ analysedFileId, removedDTCs, selectedMods }) => {
      try {
        const response = await PrivateAPI<TSaveBuildAutoResponse>({
          url: `/uploads/analyse/${analysedFileId}/auto`,
          method: 'patch',
          data: {
            removedDTCs,
            selectedMods,
          },
        })

        return response.data
      } catch (err) {
        throw new Error(getSaveBuildAutoErrorMessage(err))
      }
    },
  })
}

export default useSaveBuildAuto
